export enum JobType {
  FullTime = "FULL_TIME",
  PartTime = "PART_TIME",
  Contract = "CONTRACT",
  Temporary = "TEMPORARY",
  Internship = "INTERNSHIP",
}

export enum SalaryPeriod {
  Annual = "ANNUAL",
  Monthly = "MONTHLY",
  Hourly = "HOURLY",
}
export enum HiringUrgency {
  Immediate = "IMMEDIATE",
  Within30Days = "WITHIN_30_DAYS",
  Within60Days = "WITHIN_60_DAYS",
  Flexible = "FLEXIBLE",
}
export enum EducationLevel {
  HighSchool = "HIGH_SCHOOL",
  Associate = "ASSOCIATE",
  Bachelors = "BACHELORS",
  Masters = "MASTERS",
  PhD = "PHD",
  None = "NONE",
}

export enum JobTag {
  None = "",
  Draft = "DRAFT",
}
export enum ExperienceLevel {
  Entry = "ENTRY",
  Mid = "MID",
  Senior = "SENIOR",
  Lead = "LEAD",
  Executive = "EXECUTIVE",
}

export enum WorkMode {
  Remote = "REMOTE",
  Hybrid = "HYBRID",
  OnSite = "ON_SITE",
}
export enum PostingVisibility {
  InternalOnly = "INTERNAL_ONLY",
  ExternalOnly = "EXTERNAL_ONLY",
  Both = "BOTH",
}

export enum JobStatus {
  Draft = "DRAFT",
  UnderReview = "UNDER_REVIEW",
  Approved = "APPROVED",
  PendingPlatform = "PENDING_PLATFORM",
  Rejected = "REJECTED",
  Published = "PUBLISHED",
  Paused = "PAUSED",
  Closed = "CLOSED",
}
export enum ApplicationStatus {
  
  IN_REVIEW = "in_review",
  ON_HOLD = "on_hold",
  SHORTLISTED = "shortlisted",
  INTERVIEW_SCHEDULED = "interview_scheduled",
  INTERVIEWED = "interviewed",
  OFFERED = "offered",
  DECLINED = "declined",
  HIRED = "hired",
  REJECTED = "rejected",
  WITHDRAWN = "withdrawn",
}
/*
 <option value="beginner">Beginner</option>
            <option value="intermediate">Intermediate</option>
            <option value="advanced">Advanced</option>
            <option value="expert">Expert</option>
*/

export enum ProficiencyLevel {
  Beginner = "BEGINNER",
  Intermediate = "INTERMEDIATE",
  Advanced = "ADVANCED",
  Expert = "EXPERT",
}
export enum salaryCurrency {
  Usd = "USD",
  Inr = "INR",
  Eur = "EUR",
}
export default {
  JobType,
  SalaryPeriod,
  JobTag,
  ExperienceLevel,
  WorkMode,
  JobStatus,
  salaryCurrency,
};
